module.exports = __webpack_public_path__ + "img/feedback_wrong_loop.c2a9c40f.gif";